import React, { Fragment } from "react";
import CommonCard from "../../common/components/CommonCard";
import { Box, Divider, Grid, Typography } from "@mui/material";
import theme from "../../theme";
import CommonFormField from "../../common/components/CommonFormField";

const AcknowledgeMent = ({
    formData,
    handleInputChange,
    errors
}) => {
    return (
        <CommonCard
            paddingBottom="0px"
            border={`1px solid #0000001A`}
            borderRadius={2}
            padding="0px"
            background="#CDF9D8"
            headerContent={
                <Fragment>
                    <Box p={2}>
                        <Typography fontWeight={600} fontSize={18}>Additional Notes & Acknowledgment</Typography>
                        <Typography fontSize={14} color={theme.palette.background.dark}>Add Additional Notes & Acknowledgment</Typography>
                    </Box>
                    <Divider />
                </Fragment>
            }
            content={
                <Grid container spacing={2} p={2}>
                    <Grid item md={12}>
                        <CommonFormField
                            label="Additional Notes:"
                            type="email"
                            name="additionalNotes"
                            value={formData.additionalNotes}
                            onChange={handleInputChange}
                            placeholder="any other information you’d like to share"
                            error={errors.additionalNotes}
                            multiline
                        />
                    </Grid>
                    <Grid item md={12}>
                        <CommonFormField
                            label="Date"
                            type="date"
                            name="dates"
                            value={formData.dates}
                            onChange={handleInputChange}
                            placeholder="mm/dd/yyyy"
                            error={errors.dates}
                        />
                    </Grid>
                </Grid>
            }
        />
    )
}

export default AcknowledgeMent;